import React from "react";
import MainContents from "../organisms/MainContents";
import Pagination from "../organisms/Pagination";
import SideBar from "../organisms/SideBar";
import InterviewModal from "../organisms/InterviewModal";
import Box from "@mui/material/Box";

export default function PersonnelDetailTemplate() {
  return (
    <>
      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          mt: "40px",
          overflow: "auto",
        }}
      >
        <Box sx={{ flexGrow: 1, mr: { xs: "0px", sm: "20px" } }}>
          <MainContents />
        </Box>
        <Box
          sx={{
            flexShrink: 0,
            width: "38%",
            display: { xs: "none", sm: "block" },
          }}
        >
          <SideBar />
        </Box>
      </Box>
      <InterviewModal />
      <Box sx={{ mt: "20px" }}>
        <Pagination />
      </Box>
    </>
  );
}